export default "__VITE_PUBLIC_ASSET__f1fd3ad1__"